import usePopupsAdmin from "../../Hooks/Admin/usePopups";
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import { MuiPickersUtilsProvider, KeyboardTimePicker} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import GlobalStyles from '../../Theme/AppTheme';
import UploadImage from "./UploadImage";
import styled from "styled-components";
import { useState } from "react";
import realtimeDB from '../../Utils/api';


const ContainerPopup = styled.div``;

const ImagePopup = styled.img`
width: 25vh;`;

const ContainerEliminate=styled.div`
width: min-content;
position: relative;
top: 25px;
background-color:white;
opacity:0.5;
height:min-content;
display:flex;`;

const ContainerPopups = styled.div`
display: flex; 
gap:20px; `;

const PopupsComponent = () => 
{
    const Popups = usePopupsAdmin();

    const [LoadingUpload, setLoadingUpload] = useState(false);

    const OnUploadImage = async imageURL => 
    {
        const CartaRef= realtimeDB.ref(`/pop-ups`);

        const DateStringed =  new Date('2003-03-29T00:00:00').toISOString();

        const Payload = 
        {
            Activo: true,
            HoraInicio: DateStringed,
            HoraFin: DateStringed,
            Imagen: imageURL
        }
        
        await CartaRef.push(Payload);
    }

    const onDeletePopup = async id =>
    {
        const ref = `/pop-ups/${id}`;
        await realtimeDB.ref(ref).set(null);
    }

    const onChangeHorario = async (value,key,id) =>
    {
        const DateStringed = new Date(value).toISOString();
        await realtimeDB.ref(`/pop-ups/${id}/${key}`).set(DateStringed);
    }

    return <div>
        <UploadImage setLoading={setLoadingUpload} OnUploadImage={OnUploadImage} />

        { LoadingUpload && <p> CARGANDO </p>}

        <ContainerPopups>
            { Popups.map(popup => 
            {
                return <ContainerPopup>

                        <ContainerEliminate onClick={() => onDeletePopup(popup.id)}>
                            <DeleteOutlineIcon style={GlobalStyles.Icon} />
                        </ContainerEliminate>

                        <ImagePopup alt={popup.id} src={popup.data.Imagen}/>

                        <MuiPickersUtilsProvider utils={DateFnsUtils} >  

                            <div style={{width:"100%"}}> <KeyboardTimePicker variant="dialog"  style={{width:"100%"}}  value={popup.data.HoraInicio}  onChange={(e) => onChangeHorario(e,"HoraInicio",popup.id)} /> </div>
                            <div style={{width:"100%"}}> <KeyboardTimePicker variant="dialog"  style={{width:"100%"}}  value={popup.data.HoraFin}     onChange={(e) => onChangeHorario(e,"HoraFin",popup.id)}    /> </div>

                            
                        </MuiPickersUtilsProvider>

                    
                    </ContainerPopup>
            })}
        </ContainerPopups>
       
    </div>
}

export default PopupsComponent;